import thunk from 'redux-thunk';
import localForage from 'localforage';
import { createLogger } from 'redux-logger';
import MemoryStorage from 'redux-persist-memory-storage';

import { applyMiddleware, createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';

import rootReducer from './reducers';
import { DEVELOPMENT } from 'constants/app';
import { fetchSession } from './middleware/session';

const isStorageAvailable = () => {
  try {
    localForage.setItem('__u', 'u');
    return true;
  } catch (e) {
    return false;
  }
};

const isDebuggingInChrome = () =>
  process.env.REACT_APP_ENV !== DEVELOPMENT && !!window.navigator.userAgent;

const loggerConfig = {
  duration: true,
  collapsed: true,
  predicate: () => isDebuggingInChrome()
};

const persistConfig = {
  key: 'searchlight',
  blacklist: ['pendingOrder', 'loading', 'error', 'oauth'],
  storage: isStorageAvailable() ? localForage : new MemoryStorage()
};

const configureStore = () => {
  const store = createStore(
    persistReducer(persistConfig, rootReducer),
    applyMiddleware(thunk, createLogger(loggerConfig), fetchSession)
  );

  if (isDebuggingInChrome()) {
    window.store = store;
  }

  return {
    persistor: persistStore(store),
    store
  };
};

const { store, persistor } = configureStore();

export { store as default, persistor };
